<div matDialogTitle class="garmin-stop-history__header">
  <h1 class="garmin-stop-history__header__title" i18n="@@S_STOP_HISTORY">Stop History</h1>
  <button mat-icon-button matDialogClose class="garmin-stop-history__header__close"><mat-icon>close</mat-icon></button>
</div>

<div matDialogContent class="garmin-stop-history__content">
  <table class="garmin-stop-history__content__table">
    <thead>
      <tr>
        <th i18n="@@S_STATUS">Status</th>
        <th i18n="@@S_STATUSTIME">Status time</th>
        <th i18n="@@S_UPDATEDBY">Updated by</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of history$ | async">
        <td>{{ item.Status }}</td>
        <td>{{ item.TimeStamp }}</td>
        <td>{{ item.UpdatedBy }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div matDialogActions class="garmin-stop-history__actions">
  <button
    mat-flat-button
    matDialogClose
    color="accent"
    id="btn-tree-scoping-save"
    i18n="@@S_CLOSE"
    class="garmin-stop-history__actions__close btn-uppercase vzc-small"
  >
    Close
  </button>
</div>
